import http from "./http";

// 用户相关API
export const userApi = {
  // 发送验证码
  sendVerificationCode(phone) {
    return http.post("/togo/user/getVerifyCode", { phone });
  },

  // 用户登录
  login(data) {
    return http.post("/togo/user/login", data);
  },

  // 获取用户信息
  getUserInfo() {
    return http.post("/togo/user/getUser", {});
  },
};

// 站点相关API
export const siteApi = {
  // 获取热门站点
  getHotSites() {
    return http.post("/browser/listHotWebsite", {});
  },

  // 获取我的站点（最近使用列表）
  getMySites() {
    return http.post("/browser/listMyWebsite", {});
  },

  deleteSite(websiteId) {
    return http.post("/browser/deleteWebsite", { websiteId });
  },

  // 获取站点详情
  getSiteDetail(websiteId) {
    return http.post("/browser/getWebsiteDetail", { websiteId });
  },

  // 检查浏览器访问权限
  checkBrowserAccess(data) {
    return http.post("/browser/checkBrowserAccess", data);
  },

  checkWebsiteAccess(data) {
    return http.post("/browser/checkWebsiteAccess", data);
  },

  // 上报浏览器动作
  uploadAction(data) {
    console.log(data);
    return http.post("/browser/uploadAction", data);
  },
};

// 订单相关API
export const orderApi = {
  // 获取订单列表
  getOrders() {
    return http.post("/goods/listPayRecord", {});
  },
};

//卡密兑换
export const rechargeApi = {
  // 验证卡密
  checkCard(data) {
    return http.post("/togoCarmi/check", data);
  },
  //激活卡密
  activeCard(data) {
    return http.post("/togoCarmi/active", data);
  },
  //获取suno验证码
  sunoVerifyCode(data) {
    return http.post("/togoCarmi/sunoVerifyCode", data);
  },

};



// 商品和支付相关API
export const payApi = {
  // 获取商品列表
  getProducts() {
    return http.post("/goods/listTrafficGoods", {});
  },

  // 获取付款二维码
  getPaymentQrCode(data) {
    return http.post("/goods/getOrderQrCode", data);
  },

  // 查询付款状态
  checkPaymentStatus(orderNo) {
    return http.post("/goods/getQrCodeStatus", { orderNumber: orderNo });
  },
};
